import clsx from 'clsx';
import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...rest }, ref) {
    return (
      <input
        ref={ref}
        className={clsx(
          'w-full min-h-tap rounded-md border border-border-token bg-surface-raised',
          'px-3.5 py-2.5 text-sm text-content placeholder:text-content-muted',
          'focus:outline-none focus:ring-2 focus:ring-accent focus:border-accent',
          'disabled:opacity-50',
          className,
        )}
        {...rest}
      />
    );
  },
);
